import React, { Component } from 'react';
import _ from 'underscore';
import { connect } from 'react-redux';

import ResponsesManager from '../questions/responsesManager'
import questionActions from '../../actions/questions';
import { IncorrectSequencesInputAndConceptSelectorForm, } from '../../../Shared/index';

class NewIncorrectSequencesContainer extends Component {
  componentDidMount() {
    const { dispatch, generatedIncorrectSequences, match } = this.props;
    const { used } = generatedIncorrectSequences;
    const { params } = match;
    const { questionID } = params;
    if (!used[questionID]) {
      dispatch(questionActions.getUsedSequences(questionID, 'sentence-combining'))
    }
  }

  submitSequenceForm = data => {
    const { dispatch, history, match, questions } = this.props;
    const incorrectSequences = questions.data[match.params.questionID].incorrectSequences

    delete data.conceptResults.null;
    data.order = _.keys(incorrectSequences).length;
    const url = match.url.replace('/new', '')
    const callback = () => {
      history.push(url)
    }
    dispatch(questionActions.submitNewIncorrectSequence(match.params.questionID, data, callback));
  }

  render() {
    const { fillInBlank, generatedIncorrectSequences, match, questions, } = this.props;
    const { used } = generatedIncorrectSequences;
    const { params } = match;
    const { questionID } = params;
    return (
      <div>
        <IncorrectSequencesInputAndConceptSelectorForm
          fillInBlank={fillInBlank}
          itemLabel='Incorrect Sequence'
          onSubmit={this.submitSequenceForm}
          questionID={questionID}
          questions={questions}
          ResponsesManager={ResponsesManager}
          states
          usedSequences={used[questionID]}
        />
      </div>
    );
  }
}

function select(props) {
  return {
    fillInBlank: props.fillInBlank,
    questions: props.questions,
    generatedIncorrectSequences: props.generatedIncorrectSequences,
    states: props.states
  };
}

export default connect(select)(NewIncorrectSequencesContainer);
